module.exports = __webpack_public_path__ + "static/media/IlotC_synthese_2.07221bc6.webp";